import { Box, Typography } from '@mui/material'
import React from 'react'

import { TLandField } from '../../../EditSeasons'
import { AreaCard } from './AreaCard'

interface IModalSidebar {
  areas: (TLandField & { index?: number })[]
  colors?: { id: string; value: string }[]
  selectedAreas: string[]
  addToSelectedAreas: (id: string) => void
  originAreaId: string
}

export const ModalSidebar = ({
  areas,
  originAreaId,
  selectedAreas,
  addToSelectedAreas,
  colors
}: IModalSidebar) => {
  return (
    <Box
      sx={{
        maxHeight: '100%',
        width: 'max-content',
        overflowY: 'scroll'
      }}>
      <Typography variant="h6" p="0.25rem 0.5rem">
        Todos os Talhões
      </Typography>
      {areas.map((area, index) => {
        return (
          <AreaCard
            key={`area${index}`}
            disabledCheck={area.id === originAreaId}
            area={area}
            index={area.index ? area.index : index + 1}
            color={colors?.filter(color => color.id === area.id)?.[0]?.value || 'transparent'}
            onClick={() => addToSelectedAreas(area.id)}
            isSelected={selectedAreas.indexOf(area.id) >= 0}
          />
        )
      })}
    </Box>
  )
}
